export default {
  _not_interested_in_this_video: '이 비디오에 관심이 없습니까? %second%',
  _switch_one: '바꾸기',
}